import React from 'react';
import PropTypes from 'prop-types';
import PageWrapper from '../Wrapper/PageWrapper';
import Configurator from '../HoseConfigurator/HoseConfigurator';
import './Page.css';

export default function HoseConfigurator(props) {
  return (
    <PageWrapper
      locale={props.locale}
      setLocale={props.setLocale}
      services={props.services}
      dataStorage={props.dataStorage}
      setDataStorage={props.setDataStorage}
    >
      <div className="content-container">
        <Configurator
          products={props.services.hoseConfiguratorService.getHoseConfiguratorProducts(
            props.dataStorage, props.locale
          )}
          locale={props.locale}
          services={props.services}
          dataStorage={props.dataStorage}
        />
      </div>
    </PageWrapper>
  );
}

HoseConfigurator.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  services: PropTypes.objectOf(PropTypes.object).isRequired,
  dataStorage: PropTypes.objectOf(PropTypes.any).isRequired,
  setDataStorage: PropTypes.func.isRequired,
};
